import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'rahtab-redux';
import { ServerMerchandiseInventoryItem } from '../../hooks/InventoryHooks/useMerchandiseInventory';
import type { SliceState, Statusable } from '../../interfaces';
import { Merchandise } from './merchandisesSlice';

const initialState: MerchandiseInventorySliceState = {
  loading: 'idle',
  merchandiseInventory: {},
};

const merchandiseInventorySlice = createSlice({
  name: 'merchandiseInventory',
  initialState,
  reducers: {
    setMerchandiseInventoryLoading(state, { payload }: PayloadAction<MerchandiseInventorySliceState['loading']>) {
      state.loading = payload;
    },
    addMerchandiseInventory(state, { payload }: PayloadAction<ServerMerchandiseInventoryItem>) {
      const {
        TemplateCode: merchandiseId,
        TotalRemainingValue: remainingCount,
        StatusCode: status,
        Status: statusText,
        AssignFinallCount: loadCount,
      } = payload;
      const merchandise: MerchandiseInventory = {
        remainingQuantity: parseFloat(remainingCount),
        status: parseInt(status, 10) === 1 ? MerchandiseInventoryStatus.Active : MerchandiseInventoryStatus.Inactive,
        statusText,
        loadCount: parseFloat(loadCount),
      };
      state.merchandiseInventory[merchandiseId] = merchandise;
    },
  },
});

const { actions, reducer } = merchandiseInventorySlice;

export const { addMerchandiseInventory } = actions;

export default reducer;

export function inventoryMerchandiseSelector(id: string): (state: RootState) => Merchandise & MerchandiseInventory;
export function inventoryMerchandiseSelector(
  id: string[],
): (state: RootState) => Array<Merchandise & MerchandiseInventory>;
export function inventoryMerchandiseSelector(ids: string | string[]) {
  return (state: RootState) => {
    const { merchandise, merchandiseInventory } = state;
    if (typeof ids === 'string') return getInventoryMerchandise(ids);
    return ids.map((id) => getInventoryMerchandise(id));
    function getInventoryMerchandise(id: string): MerchandiseInventory & Merchandise {
      return {
        ...merchandise.merchandises[id],
        ...merchandiseInventory.merchandiseInventory[id],
      };
    }
  };
}
export const MerchandiseInventoryStatus = {
  Inactive: 0,
  Active: 1,
} as const;

export interface MerchandiseInventory extends Statusable<typeof MerchandiseInventoryStatus> {
  loadCount: number;
  remainingQuantity: number;
}

type MerchandiseInventorySliceState = SliceState<'merchandiseInventory', MerchandiseInventory>;
